import React from "react";
import ReactTable from "react-table";
import ContactCenter from "../../../../types/ContactCenter";

interface Props {
  data: ContactCenter[];
  onSelectionChange: (selected: any[]) => void;
}

export const ConfiguracionContactCenterTable: React.FC<Props> = ({
  data,
  onSelectionChange
}) => {
  const [selectedRows, setSelectedRows] = React.useState<Set<number>>(
    new Set()
  );

  const toggleRow = (index: number) => {
    const newSelected = new Set(selectedRows);
    if (newSelected.has(index)) {
      newSelected.delete(index);
    } else {
      newSelected.add(index);
    }
    setSelectedRows(newSelected);

    const selectedIds = data
      .filter((_, i) => newSelected.has(i))
      .map(item => item.id);
    onSelectionChange(selectedIds);
  };

  const toggleAll = () => {
    if (selectedRows.size === data.length) {
      setSelectedRows(new Set());
      onSelectionChange([]);
    } else {
      setSelectedRows(new Set(data.map((_, i) => i)));
      onSelectionChange(data.map(item => item.id));
    }
  };

  const columns = [
    {
      Header: () => (
        <input
          type="checkbox"
          checked={selectedRows.size === data.length && data.length > 0}
          onChange={toggleAll}
        />
      ),
      accessor: "seleccionado",
      Cell: (row: any) => (
        <input
          type="checkbox"
          checked={selectedRows.has(row.index)}
          onChange={() => toggleRow(row.index)}
        />
      ),
      width: 50,
      filterable: false,
      sortable: false
    },
    {
      Header: "No Empleado",
      accessor: "numeroEmpleado"
    },
    {
      Header: "Nombre",
      accessor: "nombre"
    }
  ];

  if (data == null) {
    return null;
  }

  return (
    <>
      <div>
        <ReactTable
          data={data}
          columns={columns}
          defaultPageSize={data.length || 10}
          sortable={false}
          resizable={false}
          showPagination={false}
          className="-striped -highlight"
          previousText="Anterior"
          nextText="Siguiente"
          loadingText="Cargando..."
          noDataText="No hay registros"
          pageText="Página"
          ofText="de"
          rowsText="filas"
        />
      </div>
    </>
  );
};
